import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * A password box with a show / hide eye button. Works with any input component
 * (pass `as`) so it keeps each page's own styling.
 */
const PasswordInput = forwardRef(function PasswordInput({ as: Comp = "input", className, ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Comp ref={ref} {...props} type={show ? "text" : "password"} className={cn(className, "pr-10")} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        title={show ? "Hide password" : "Show password"}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 h-8 w-8 rounded-md grid place-items-center text-muted2 hover:text-ink hover:bg-surface"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
